export const COMBO_LOCALE = {
    placeholder: 'è«é¸æ',
    emptyMsg: 'æ«ç¡æ¸æ'
};
